module.exports = __webpack_public_path__ + "static/bnr_square@3x-941e558b06b55e1e0a0b6fc8c0c3e1c2.webp";